module.exports = __webpack_public_path__ + "img/Xgrow-12-pt.bee3065e.png";